import React from 'react';
import './App.css';
import Header from './components/Header/Header';
import User from './components/User/User';
function App() {
  return (
    <div >
    <Header></Header>
    <User></User>
    </div>
  );
}

export default App;